const BASE = 'technical/program-planner';

export const getDashboardDataApi = () => `${BASE}/analytics/overview`;